import { GET_ACTIVITY_LOG } from "./../graphql/queries/getActivityLog"
import { useQuery } from "@apollo/client"

export const useActivityLog = (first?: number, skip?: number) => {
  const { data, error, loading, refetch } = useQuery(GET_ACTIVITY_LOG, {
    variables: {
      first: first,
      skip: skip,
    },
  })
  return {
    organizationActivities: data?.myOrganization,
    error,
    isLoading: loading,
    refetch,
  }
}
